module.exports = __webpack_public_path__ + "img/FILTER.f25b3129.svg";